import React from 'react';
import { Wheelchair, WheelchairInactive } from '../Icons/CustomIcons';

const ActivityWheelchairIndicator = ({ wheelchairAccessible }) => (
  <span className={`activity-detail-wheelchair ${wheelchairAccessible ? 'activity-detail-wheelchair--yes' : 'activity-detail-wheelchair--no'}`}>
    {wheelchairAccessible
      ? <><Wheelchair size={20} /> Rollstuhlgerecht</>
      : <><WheelchairInactive size={20} /> Nicht rollstuhlgerecht</>}
  </span>
);

export default ActivityWheelchairIndicator;
